import { QuizQuestion, QuizRevision, DocQuizRevision } from '.';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type QuizQuestionChoice =
   | string
   | {
        value: string;
        text: string;
        imageLink: string;
     };

export type QuizQuestionJson = {
   name: string;
   type: string;
   inputType: string;
   min: number;
   max: number;
   title: string;
   correctAnswer: string | null;
   choices: Array<QuizQuestionChoice> | null;
   labelTrue?: string;
   labelFalse?: string;
   showNoneItem?: boolean;
   showOtherItem?: boolean;
   otherText?: string;
   noneText?: string;
   answerIsOther?: boolean;
   imageLink?: string;
   altText?: string;
   contentMode?: string;
   mediaType?: string;
   imageId?: number;
   caption?: string;
};

export type Quiz = {
   quizid: number;
   quiz_revisionid: number;
   created_at: number;
   author: number;
   deleted: boolean;
};

export type QuizPageJson = {
   elements: Array<QuizQuestionJson>;
};

export type QuizJson = {
   title: string;
   description: string | null;
   pages: Array<QuizPageJson>;
   questionsOrder: 'default' | 'random' | null;
};

export type GetQuizResponse = {
   quizid: number;
   quizRevisionid: number;
   data: string | null;
   quiz: Quiz;
   current_doc_quiz_revision: DocQuizRevision;
   doc_quiz_revisions: DocQuizRevision[];
   quiz_revision: QuizRevision;
   questions: Array<QuizQuestion>;
   quiz_json: QuizJson;
   nonMediaQuestionsCount: number;
};

export async function getQuiz(
   quizid: number,
   includeAnswers: boolean = false,
   defaultOrder: boolean = false,
   quizRevisionid: number | null = null,
   { ...common }: CommonRequestOptions = {}
): Promise<GetQuizResponse> {
   let query: any = {
      quizRevisionid,
   };
   if (includeAnswers) {
      query['includeAnswers'] = includeAnswers;
   }
   if (defaultOrder) {
      query['defaultOrder'] = defaultOrder;
   }
   return makeRequest('get', `/quizzes/${quizid}`, {
      ...common,
      query,
   });
}
